import Vue from 'vue'
import Router from 'vue-router'
import Frontpage from '@/Frontpage'
import Closednotice from '@/Closednotice'
import Category from '@/Category'
import Company from '@/Company'
import Contact from '@/Contact'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    /*{
      path: "/",
      redirect: "/hello"
    },*/

    {
      path: '/',
      component: Closednotice,
    },
    {
      path: '/oldfp',
      component: Frontpage,
      props: route => ({ qname: route.query.name })
    },
    {
      path: '/kategoria/*',
      component: Category,
      props: route => ({ category: route.params.pathMatch })
    },
    {
      path: '/yritys/*',
      component: Company,
      props: route => ({ companyid: route.params.pathMatch })
    },
    {
      path: '/yhteys',
      component: Contact
    }
  ]
})
